// Turns a Loom workflow into what the Workflows tab shows. Loom only stores the steady state that
// Mastra last reported, not each step it ran, so the stepper is the lead intake's three stages
// and TEAM_REVIEW is a pause inside the second stage rather than a step of its own.

export const LEAD_INTAKE_STEPS = ['IntakeReceived', 'ContactingLead', 'Finished'];

// Pill has no success or error variant, so those two tones carry their own colours.
export const TONE_PILL_PROPS = {
  info: {variant: 'info'},
  warning: {variant: 'warning'},
  neutral: {variant: 'neutral'},
  success: {backgroundColor: '#F0FDF4', borderColor: '#BBF7D0', textColor: '#15803D'},
  error: {backgroundColor: '#FEF2F2', borderColor: '#FECACA', textColor: '#B91C1C'},
};

const describeState = (workflow) => {
  if (workflow.steadyState === 'BOOKED') {
    return {state: 'BOOKED', activeStep: LEAD_INTAKE_STEPS.length, tone: 'success', finishedStep: 'Booked'};
  }

  if (workflow.steadyState === 'CLOSED' || workflow.status !== 'ACTIVE') {
    return {state: 'CLOSED', activeStep: LEAD_INTAKE_STEPS.length, tone: 'neutral', finishedStep: 'Closed'};
  }

  if (!workflow.engineRunBound) {
    return {state: 'NOT_STARTED', activeStep: 0, tone: 'error'};
  }

  if (!workflow.steadyState) {
    return {state: 'PROCESSING', activeStep: 0, tone: 'info'};
  }

  if (workflow.steadyState === 'AWAIT_LEAD_ACTION') {
    return {state: 'AWAITING_LEAD', activeStep: 1, tone: 'info'};
  }

  if (workflow.steadyState === 'TEAM_REVIEW') {
    return {state: 'TEAM_REVIEW', activeStep: 1, tone: 'warning'};
  }

  // A steady state this page does not know yet still sits inside the active workflow.
  return {state: 'IN_PROGRESS', activeStep: 1, tone: 'info'};
};

// Only an active workflow can need attention: a finished one has nothing left to unblock.
const describeAttention = (workflow) => {
  if (workflow.status !== 'ACTIVE') return [];

  const attention = [];

  if (!workflow.engineRunBound) attention.push('NoEngineRun');
  if (workflow.escalations.some((escalation) => escalation.deliveryStatus === 'FAILED')) {
    attention.push('EscalationFailed');
  }

  return attention;
};

export const describeWorkflow = (workflow) => ({
  ...describeState(workflow),
  attention: describeAttention(workflow),
});

// Loom adds Signal kinds over time, so an unknown kind still reads as words instead of a missing
// translation.
export const humanizeKind = (kind) => {
  const words = (kind || '').toLowerCase().split('_').filter(Boolean).join(' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};
